export default function isTouch () {
  return window.matchMedia('(pointer: coarse)').matches
}




// WEBPACK FOOTER //
// ./F:/Development/geoviewer2/src/util/isTouch.js